<div class="outbound-outer-container">
  <app-current-path></app-current-path>
  <div class="console-container">
      <div class="page-header">{{ pageHeader }}</div>
      <div class="IVRMessage">
          <div class="IVRMessageContent">{{ getRequestType() }}</div>
      </div>
      <div class="labelHead">
          {{ sectionHeader }}
      </div>
      <hr class="hrRow" />

      <div class="btn-wrapper text-end">
          <button *ngIf="!hideUnknownNewbtn" class="button" (click)="handleUnknownContact()">Unknown Contact</button>
          <button class="button" (click)="handleDisconnectCall()">Disconnect Call</button>
      </div>
      <div class="find-user">Find User By:</div>
      <div *ngIf="showSearch == true">
          <app-search-dialog (selectedSearchedItem)="handleSelectedUser($event)"
                             (notFoundAddNew)="handleSelectedUser($event)"
                             [searchObject]="searchMemberObject"
                             [hideNotFoundButton]="false"
                             [addUserRequired]="false"></app-search-dialog>
      </div>
  </div>
</div>
